import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor() {
    if (environment.bypassAuth && environment.staticAuth?.token) {
      const existingToken = localStorage.getItem('token');

      if (!existingToken) {
        console.log(
          '%c[LOCAL DEV MODE]',
          'color: #00b894; font-weight: bold;',
          'Injecting static credentials from environment.local.development.ts'
        );

        localStorage.setItem('token', environment.staticAuth.token);
        localStorage.setItem('userid', String(environment.staticAuth.UserID));
        localStorage.setItem('fullName', environment.staticAuth.UserName);
        localStorage.setItem('city', 'Local Environment');
        localStorage.setItem(
          'role',
          JSON.stringify({ roleId: 0, name: 'Developer' })
        );
        localStorage.setItem(
          'branch',
          JSON.stringify({
            branchId: 0,
            branchName: 'Local Dev Branch',
            city: 'Local City',
          })
        );
        localStorage.setItem(
          'permissions',
          JSON.stringify([
            {
              id: 1,
              name: 'All Access (Local Dev)',
              permissionSubCategories: [],
            },
          ])
        );
      } else {
        console.log(
          '%c[LOCAL DEV MODE]',
          'color: #0984e3; font-weight: bold;',
          'Static credentials already initialized.'
        );
      }
    }
  }

  getHeaders() {
    return {
      headers: new HttpHeaders()
        // .set('Content-Type', 'application/json')
        .set('Authorization', 'Bearer ' + this.getToken),
    };
  }

  get getToken() {
    return localStorage.getItem('token') || sessionStorage.getItem('token');
  }

  get getFullname() {
    return (
      localStorage.getItem('fullName') || sessionStorage.getItem('fullName')
    );
  }

  get getUserId() {
    return localStorage.getItem('userid');
  }

  get getCity() {
    return localStorage.getItem('city') || sessionStorage.getItem('city');
  }

  get getUrl() {
    return environment.apiUrl;
  }

  get IsFoundIPAddress() {
    return localStorage.getItem('IsFoundIPAddress');
  }

  get getBranch() {
    const branch = JSON.parse(localStorage.getItem('branch'));
    return branch;
  }

  get getRole() {
    const role = JSON.parse(localStorage.getItem('role'));
    return role;
  }
  get getRegister() {
    const register = JSON.parse(localStorage.getItem('register'));
    return register;
  }

  get getPermissions() {
    const permissions = JSON.parse(localStorage.getItem('permissions'));
    return permissions;
  }

  get checkIfSessionClose() {
    const session = localStorage.getItem('closeSession');
    return session;
  }

  get getCasherPermissions() {
    const isSelected =
      this.getPermissions[1]?.permissionSubCategories[2].permissionItems[0]
        .selected;
    return isSelected;
  }

  get getOpenCloseRegesterPermissions() {
    const isSelected =
      this.getPermissions[1]?.permissionSubCategories[2].permissionItems[0]
        .selected;
    return isSelected;
  }

  get getCollectPermissions() {
    const isSelected =
      this.getPermissions[1]?.permissionSubCategories[3].permissionItems[0]
        .selected;
    return isSelected;
  }

  get timeRegister() {
    const timeRegister = localStorage.getItem('timeRegister');
    return timeRegister;
  }
}
